import { i18n } from '@fs/zion-locale'
import { type LocaleName } from './types'

export function getLocaleName(nameObj: LocaleName = {}, nativeLocale = 'en'): string {
  const i18nLanguageName = nameObj?.[i18n.language]
  const englishName = nameObj?.en
  const nativeLanguage = nameObj?.[nativeLocale]
  const firstName = Object.values(nameObj)?.[0]
  return i18nLanguageName || nativeLanguage || englishName || firstName || 'Not Found'
}

export function propertySort<T extends Record<string, unknown>>(
  property: keyof T,
  ascending = true
): (a: T, b: T) => number {
  return (a: T, b: T) => {
    let result = 0
    if (typeof a[property] === 'string') {
      result = (a[property] as string).localeCompare(b[property] as string)
    } else if (typeof a[property] === 'number') {
      result = (a[property] as number) - (b[property] as number)
    } else if (typeof a[property] === 'object') {
      const nativeLocaleA = (a as { native_lang?: string })?.native_lang || 'en'
      const nativeLocaleB = (b as { native_lang?: string })?.native_lang || 'en'
      result = getLocaleName(a[property] as LocaleName, nativeLocaleA)?.localeCompare(
        getLocaleName(b[property] as LocaleName, nativeLocaleB)
      )
    }
    return ascending ? result : -1 * result
  }
}
